//Angular References
import { Component, OnInit, AfterViewInit, ViewChild, ViewEncapsulation, NgZone, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import * as moment from 'moment';

import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

import { MatSort } from '@angular/material/sort';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { PageEvent } from '@angular/material/paginator';
import { MatRadioChange } from '@angular/material/radio';
import { MatInput } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';

import { FeaturePermissions, User, UserResponse } from '../../../models/user.model';
import { ContractDetails, ContractDetailsResponse, ContractSession, ContractSessionResponse, ContractSessionListResponse } from '../../../models/contractsession.model';
import { InventionDetails, InventionResponse, InventionContact, InventionContactResponse } from '../../../models/invention.model';
import { ContactDetails, ContactListResponse, CLPUserOffice, ContactResponse } from '../../../models/contact.model';
import { InventionWizard, InventionWizardResponse } from '../../../models/wizard.model';
import { ConfigDocumentsResponse, ConfigDocuments, GenerateContractsAzure, ContractsAzureDetailsResponse, ContractsSingalFile, AzureMedia } from '../../../models/document.model';
import { ProductListResponse, ProductDetails, ProductResponse } from '../../../models/product.model';
import { SimpleResponse } from '../../../models/genericResponse.model';
import { ContractActionLog } from '../../../models/contractActionLog.model';
import { UserNMIKeys } from '../../../models/configMaster.model';
import { OfficeList, OfficeListResponse } from '../../../models/officelist.model';

import { UtilityService } from '../../../services/shared/utility.service';
import { ContractSessionService } from '../../../services/contractsession.service';
import { InventionService } from '../../../services/invention.service';
import { DocumentService } from '../../../services/document.service';
import { ContactService } from '../../../services/contact.service';
import { UserService } from '../../../services/user.service';
import { WizardService } from '../../../services/wizard.service';
import { ProductService } from '../../../services/product.service';
import { ContratActionLogService } from '../../../services/contratActionLog.service';
import { TransferDataService } from '../../../services/shared/transferData.service';
import { ConfigMasterService } from '../../../services/configMaster.service';
import { OfficeService } from '../../../services/office.service';
import { isNullOrUndefined } from '@swimlane/ngx-datatable/release/utils';
import { ContractPayment, ContractPaymentResponse } from '../../../models/contractPayment.model';
import { AddendumServicesResponse } from '../../../models/addendum.model';
import { StateService } from '../../../services/state.service';
import { State } from '../../../models/state.model';
import { BillingService } from '../../../services/billing.service';
import { NavigationService } from '../../../services/navigation.service';
import { Navigation, NavigationResponse } from '../../../models/navigation.model';
import { AddendumService } from '../../../services/addendum.service';
import { AppconfigService } from '../../../services/shared/appconfig.service';

//For jquery
declare var $: any;

@Component({
    selector: 'app-patent-plus-contract-list',
    templateUrl: './patent-plus-contract-list.component.html',
    styleUrls: ['./patent-plus-contract-list.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
/** contract-list component*/
export class PatentPlusContractListComponent implements OnInit, AfterViewInit {

    displayedColumns = ['inventionName', 'inventorName', 'productName', 'userName', 'contractStatus', 'contract', 'lastUpdatedDate', 'closureDate', 'Documents', 'actions'];

    displayedContactColumns = ['firstname', 'email'];
    displayedInventionCols = ['inventName', 'stepName'];
    displayedGenContractColumns = ['fileName', 'dtCreated', 'unZipDoc', 'zipDoc'];
    displayedSingleFileColumns = ['fileName', 'unZipDoc'];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatPaginator) contactPaginator: MatPaginator;

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('sortContact') sortContact: MatSort;
    @ViewChild('sortDocPopUp') sortDocPopUp: MatSort;

    @ViewChild(MatInput) search: MatInput;
    @ViewChild(MatInput) searchInvention: MatInput;

    @ViewChild('fromInput', { read: MatInput }) fromInput: MatInput;
    @ViewChild('toInput', { read: MatInput }) toInput: MatInput;

    dataSource = new MatTableDataSource([]);
    isInventionExist: boolean;

    dataSourceContact: any;
    dataSourceInvention: any;
    dataSourceGenContractPopUp: any;
    dataSourceSingleFile: any;

    pageSize: any;
    pageEvent: any = PageEvent;
    private globalResponse: any;
    contractListForm: FormGroup;
    isLoading: boolean = false;
    isContactSelected: boolean = false;
    currentUser: User;
    officeNumber: number = 0;
    refreshData: boolean = false;
    range: boolean = false;
    _sortCol: string;
    _sortDir: string;
    private _searchTerm: string;
    selectedRowIndex: number = -1;
    panelOpenState = false;
    mySOSite: string = '';
    inventHelpSite: string = '';
    document: string = 'loading...';
    chkContactList: boolean = false;
    inventionId: number;
    isClientRemote: boolean = false;
    isRemote: boolean = false;
    isContractRemote: boolean = false;
    isContractInvRemote: boolean = false;
    countryID: number = 1;
    isContExists: boolean = false;
    productId: number = 0;
    clpUserId: number = 0;
    inventionName: string;
    contactId: number = -1;
    contactIdParam: number = -1;
    officeNum: number = -1;
    contactName: string = "";
    validateState: any;
    checkState: string = "";
    inventionDefaultName: string = "";
    searchContactText: string = "NoSearch";
    inventorName: string = "";
    contractSessionId: number = 0;
    deletecontractSessionId: number = 0;
    isNewInvention: boolean = true;
    isBIPClient: boolean = false;
    isSubClient: boolean = false;
    isFirstOnExisting: boolean = false;
    isSecondContract: boolean = false;
    exInventionName: string = '';
    exInventionId: number = 0;
    oldInventHelp: string = "";
    isOldInventHelp: boolean = false;
    isProductExists: boolean = false;
    encryptedUser: string = '';
    mySoUrl: any;
    inventHelpURL: any;
    inventHelp_CS_Site: any;
    fileNumberURL: string;
    clpUserIdCount: number = 0;
    contractDetails: ContractDetails[];
    contractDetailsResponse: ContractDetailsResponse;
    contractSession: ContractSession;
    contractSessionResponse: ContractSessionResponse;
    contractSessionListResponse: ContractSessionListResponse;
    contactDetails: ContactDetails[];
    contactDetail: ContactDetails;
    contactListResponse: ContactListResponse;
    contactResponse: ContactResponse;
    configDocumentsResponse: ConfigDocumentsResponse;
    configDocuments: ConfigDocuments;
    clpUserOffice: CLPUserOffice;
    userResponse: UserResponse;
    userNMIKeys: UserNMIKeys;

    inventionWizard: InventionWizard[];
    inventionWizardResponse: InventionWizardResponse;
    inventionContact: InventionContact[];
    inventionContactResponse: InventionContactResponse;
    inventionDetails: InventionDetails;
    inventionResponse: InventionResponse;
    productListResponse: ProductListResponse;
    productResponse: ProductResponse;
    productDetails: ProductDetails[];
    productDetail: ProductDetails;
    simpleResponse: SimpleResponse;
    contractActionlog: ContractActionLog;
    officeListResponse: OfficeListResponse;
    officeList: OfficeList[];
    private contractPayment: ContractPayment;
    private addendumServicesResponse: AddendumServicesResponse;
    ContractPaymentResponse: ContractPaymentResponse;
    private navigationResponse: NavigationResponse;
    private navigation: Navigation;
    gencontractDetailsResponse: ContractsAzureDetailsResponse;
    generateContractsAzure: GenerateContractsAzure[];
    generateContractsMedia: GenerateContractsAzure[];
    permissionResponse: FeaturePermissions;
    selectedIndex: number = 0;
    selectedIndx: number = 0;
    highlightedRows = [];
    stateList: State[];
    filterUserStateLst: State[];
    filteredStateList: State[];
    selectedRecord;
    filteredRows: any;
    selected = new FormControl(0);

    //title = 'ClientApp';
    //txtMessage: string = '';
    //uniqueID: string = new Date().getTime().toString();
    //messages = new Array<Message>();
    //message = new Message();   
    ContractSessionId: number;
    hide_waiting_close: boolean = false;
    isWestern: boolean = false;
    isStateExists: boolean = false;
    finaldocument: string;
    flgInstallment: boolean = false;
    isWaitStateExists: boolean = false;
    isROISubmitted: boolean = false;
    isWaitingPeriod: boolean = false;
    isWaitStateDoc: boolean = false;
    loading: boolean = false;
    popLoading: boolean = false;
    pop2Loading: boolean = false;
    dvSpinner: boolean = false;
    chkExpPDF: boolean = false;
    isExecuted: boolean = false;
    refreshGenContact: any;
    docTitle: string;
    docContaint: string;
    checkOtherCountry: boolean = false;
    singalDownload: ContractsSingalFile[] = [];
    productYCutOffDate: any;
    isBIPExist: boolean = false;
    /** contract-list ctor */
    constructor(private fb: FormBuilder,
        private _router: Router,
        private _route: ActivatedRoute,
        private _contractSessionService: ContractSessionService,
        private _contactService: ContactService,
        private _inventionService: InventionService,
        private _productService: ProductService,
        private _wizardService: WizardService,
        private _documentService: DocumentService,
        private _ngZone: NgZone,
        private _userService: UserService,
        private _utilityService: UtilityService,
        private _cdref: ChangeDetectorRef,
        private _contractActionLogService: ContratActionLogService,
        private _transferDataService: TransferDataService,
        private _configMasterService: ConfigMasterService,
        private _officeService: OfficeService,
        private _snackBar: MatSnackBar,
        private _stateService: StateService,
        private _billingService: BillingService,
        private _navigationService: NavigationService,
        private _addendumService: AddendumService,
        private _appconfigService: AppconfigService) {

        this._route.queryParamMap.subscribe(params => {
            if (params.has('r')) {
                this.encryptedUser = params.get('r');
                this._userService.getAuthenticateR(this.encryptedUser)
                    .then(res => {
                        if (res) {
                            if (res.isvalid) {
                                this.userResponse = UtilityService.clone(res);
                                console.log("Valid User");
                            } else {
                                this._router.navigate(['/unauthorized']);
                            }
                        } else {
                            this._router.navigate(['/unauthorized']);
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        console.log("Client side Error : " + err);
                        this._utilityService.handleErrorResponse(err);
                    });
            }
            else {
                console.log('no r');
                this._router.navigate(['/unauthorized']);
            }
        });

    }

    ngOnInit(): void {
        this.contractListForm = this.fb.group({
            fldSearchTerm: [''],
            contract: [{ value: 1 }],
            contractInvention: [{ value: -1 }],
            contractType: [{ value: 11 }],
            isClientRemote: [{ value: false }],
            isContractRemote: [{ value: false }],
            isContractInvRemote: [{ value: false }],
            inventionName: ['', [Validators.required]],
            inventionContName: ['', [Validators.required]],
            //contractCountry: [{ value: 1 }],
            //contractInvCountry: [{ value: 1 }],
            clientCountry: [{ value: 1 }]
        });
        this.contractListForm.patchValue({
            contract: 1,
            contractInvention: -1,
            contractType: 11,
            isClientRemote: false,
            isContractRemote: false,
            isContractInvRemote: false,
            inventionName: 'Invention Name',
            inventionContName: 'Invention Name',
            //contractCountry: 1,
            //contractInvCountry: 1,
            clientCountry: 1
        });
        //this.identifyUserRole();
        this.fetchStateList();
        this.loadDocumentType();
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.identifyUserRole();
    }

    UpdateContractActionlog(contractSessionId: number, Action: string) {

        this._contractActionLogService.getContractActionLogOb(this.encryptedUser, this.contractSessionId)
            .subscribe(
                (result: ContractActionLog) => {
                    this.contractActionlog = result;
                    this.updateContractLogObjectModel(Action);
                    this.saveContractActionLog();
                    this.navigateToContract();
                },
                error => {
                    console.error(error);
                }
            );
    }

    navigateToContract() {
        if (this.encryptedUser) {
            if (this.isClientRemote || this.isContractRemote || this.isContractInvRemote) {
                this._transferDataService.contractInitiate = true;
                this._router.navigate(['/patent-plus-contract-remote', this.contactId, this.inventionId, this.contractSessionId, this.clpUserIdCount > 1 ? this.clpUserId : 0], {
                    queryParams: { w: 1, 'i': this.inventionId, 'c': this.contactId, 'cs': this.contractSessionId, 'rd': this.clpUserIdCount > 1 ? this.clpUserId : 0, 'r': this.encryptedUser } //'MI8i%2FEO8A6br5g%2BQ3nRm3VLhqCmgoV0HuhDGAQ66KTF%2F2LIN%2BaqN2WmdNTEPLSAl2fmY1N4QfjJrjej4OolKwA%3D%3D'
                });
            }
            else {
                this._router.navigate(['/patent-plus-contract', this.contactId, this.inventionId, this.contractSessionId, this.clpUserIdCount > 1 ? this.clpUserId : 0], {
                    queryParams: { w: 1, 'i': this.inventionId, 'c': this.contactId, 'cs': this.contractSessionId, 'rd': this.clpUserIdCount > 1 ? this.clpUserId : 0, 'r': this.encryptedUser }
                });
            }
        }
    }

    updateContractLogObjectModel(Action: string) {
        switch (Action) {
            case "socSubmit":

                break;
            case "socDocSign":

                break;
            case "":
                this.contractActionlog.contractSessionId = this.contractSessionId;
                this.contractActionlog.inventionId = this.inventionId;
                this.contractActionlog.productId = this.productId == 0 ? 1 : this.productId;
                this.contractActionlog.createdBy = this.clpUserId;
                this.contractActionlog.audiFlag = false;
            //default:
        }
    }

    async saveContractActionLog() {
        if (this.contractActionlog.inventionId > 0) {
            await this._contractActionLogService.updateContractActionLog(this.encryptedUser, this.contractActionlog)
                .then(res => {
                    if (res) {
                        this.contractActionlog = UtilityService.clone(res);
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    get contractListFb() { return this.contractListForm.controls; }

    ngAfterContentChecked() {
        this._cdref.detectChanges();
    }

    private async showInvention(contactId, inventionId, ContractSessionId, isHtml, contractStatus) {
        if (isHtml) {
            $('#modalContactList').modal('hide');
            $('#modalInventionList').modal('hide');
        }
        if (ContractSessionId > 0 && !isNullOrUndefined(ContractSessionId)) {
            await this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, ContractSessionId)
                .then(res => {
                    if (res) {
                        this.contractSession = UtilityService.clone(res);
                        this.isRemote = this.contractSession.isClientRemote;
                        if (!isHtml) {
                            this.loadProduct(this.contractSession.productId, this.contractSession.CountryID);
                            this.loadNavigationWizard(inventionId, ContractSessionId, contractStatus);
                            this.loadUserState(this.contractSession.clientState, this.contractSession.CountryID);
                        }
                        else if (isHtml) {
                            if (this.encryptedUser) {
                                if (this.isRemote) {
                                    this._transferDataService.contractInitiate = true;
                                    this._router.navigate(['/patent-plus-contract-remote', contactId, inventionId, ContractSessionId, this.clpUserIdCount > 1 ? this.clpUserId : 0], {
                                        queryParams: { w: 1, 'i': inventionId, 'c': contactId, 'cs': ContractSessionId, 'rd': this.clpUserIdCount > 1 ? this.clpUserId : 0, 'r': this.encryptedUser }
                                    });
                                }
                                else {
                                    this._router.navigate(['/patent-plus-contract', contactId, inventionId, ContractSessionId, this.clpUserIdCount > 1 ? this.clpUserId : 0], {
                                        queryParams: { w: 1, 'i': inventionId, 'c': contactId, 'cs': ContractSessionId, 'rd': this.clpUserIdCount > 1 ? this.clpUserId : 0, 'r': this.encryptedUser }
                                    });
                                }
                            }
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }


    private async loadProductList() {
        let inventId: number = 0;
        if (this.inventionId)
            inventId = this.inventionId;

        await this._productService.getProductListAsync(this.encryptedUser, inventId, 1, "Plus")
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.productListResponse = UtilityService.clone(res);
                        this.productDetails = this.productListResponse.productDetails.filter(product => new Date(this.productYCutOffDate.configValue) <= new Date() ? product.productId != 7 : product);
                    } else {
                        console.log("Product result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    highlight(row) {
        this.dataSourceInvention = null;
        this.selectedIndx = 0;
        this.isContactSelected = true;
        this.selectedRowIndex = 2;
        this.highlightedRows = [];
        this.highlightedRows.push(row);
        this.contactName = row["firstname"] + ' ' + row["lastname"];
        $('#informMsg').text('');
        this.isInventionExist = false;
        $('#dvContactInventions').html("");
        //this.inventionDefaultName = row["lastname"] + ' Invention';
        $('#inventionName').val(row["lastname"] + ' Invention');

        this.contactId = row["contactid"];
        this.loadContact();
        this._inventionService.getInventionByContactIdAsync(this.encryptedUser, this.contactId, this.clpUserId, "Plus")
            .then(res => {

                if (res)
                    this.inventionContactResponse = UtilityService.clone(res);

                if (this.inventionContactResponse) {
                    this.inventionContact = UtilityService.clone(this.inventionContactResponse.inventionContact);
                    if (this.inventionContact.length > 0) {
                        const ELEMENT_INVENTION_CONTACT: InventionContact[] = this.inventionContact;
                        this.dataSourceInvention = new MatTableDataSource(ELEMENT_INVENTION_CONTACT);
                        this.applyInventionFilter(this.searchInvention.value);
                        this.selectedIndx = 1;
                        $('#informMsg').text(this.inventionContact.length + ' invention(s) exists.');
                        //console.log(this.countUnique(this.inventionId))
                    }
                    else {
                        $('#informMsg').text('No invention exists.');
                        this.selectedIndx = 0;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.isLoading = false;
                this._utilityService.handleErrorResponse(err);
            });

    }

    countUnique(iterable) {
        return new Set(iterable).size;
    }

    getMySoSite() {
        this._wizardService.getSiteAsync(this.encryptedUser)
            .then(res => {
                if (res)
                    this.simpleResponse = UtilityService.clone(res);

                if (this.simpleResponse) {
                    this.mySOSite = this.simpleResponse.messageString;
                    this.getInventHelpSite();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.isLoading = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    getInventHelpSite() {
        this._wizardService.getEvolveCSSiteURLAsync(this.encryptedUser)
            .then(res => {
                if (res)
                    this.simpleResponse = UtilityService.clone(res);

                if (this.simpleResponse) {
                    this.inventHelpSite = this.simpleResponse.messageString;
                    //this.prepareInventionDetails(this.inventionWizard);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.isLoading = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    prepareInventionDetails(invWizard) {
        let sTemplate: string = '';
        let intCount: number = 0
        let intLastInventionID: number = 0;
        let intLastWiardID: number = 0;
        let intRowCount: number = 0;
        let arrDocTypeId = Array();
        let strDocName: string = '';
        sTemplate = ("<table>");
        for (var i = 0; i < invWizard.length; i++) {
            intRowCount += 1;
            if (intLastInventionID != invWizard[i]["inventionId"]) {
                intCount += 1;
                sTemplate += "<tr><td style='font-weight: bold;'>" + intCount.toString() + ". " + invWizard[i]["inventionName"] + "</td></tr>";
                intLastWiardID = 0;
            }
            if (intLastWiardID != invWizard[i]["wizardId"]) {
                sTemplate += "<tr><td style='padding-left: 30px; font-size:11px;'><span style='font-size:10pt;'>&#8226;</span>" + invWizard[i]["wizard"];
            }

            if (invWizard[i]["wizardStage"] == "Complete") {
                if (invWizard[i]["documentTypeIds"] != null) {
                    let strDIDs: string = invWizard[i]["documentTypeIds"];
                    arrDocTypeId = strDIDs.split(',');

                    if (arrDocTypeId.length > 1) {
                        for (var j = 0; j < arrDocTypeId.length; j++) {
                            if (arrDocTypeId[i] > 0) {
                                strDocName = this.getDocumentName(arrDocTypeId[i]);

                                if (invWizard[i]["documentTypeIds"] != "Patent Search Only" && strDocName != "Patent Search Opinion Request") {
                                    sTemplate += "&nbsp;&nbsp;&nbsp;<a href='" + this.mySOSite + "/customevlv/docs.aspx?iid=" + invWizard[i]["inventionId"] + "&dids=" + arrDocTypeId[i] + "' title='" + strDocName + "'><IMG src='../images/framework/iconpdfquick.png' border=0 ></a>";
                                }
                            }
                        }
                        sTemplate += "</td></tr>";
                    }
                    else {
                        strDocName = this.getDocumentName(strDIDs);
                        sTemplate += "<a href='" + this.mySOSite + "/customevlv/docs.aspx?iid=" + invWizard[i]["inventionId"] + "&dids=" + strDIDs + "' title='" + strDocName + "'><IMG src='../images/framework/iconpdfquick.png' border=0 ></a></td></tr>";
                    }
                } else {
                    sTemplate += " (Completed)</td></tr>";
                }
            } else {
                sTemplate += "</td></tr>";

                switch (invWizard[i]["wizardStage"]) {
                    case "Form": break;
                    case "Billing": break;
                    default: {
                        sTemplate += "<tr><td style='padding-left: 60px;font-size:10px;'>" + invWizard[i]["wizardStage"] + "</td></tr>";
                    }
                }
                sTemplate += "<tr> <td style='padding-left: 80px;font-size:9px;' class='buttonsbar' > <a href='" + this.mySOSite + "/customevlv/redir_cs.aspx?p=" + this.inventHelpSite + "hub/&w=" + invWizard[i]["wizardId"] + "&i=" + invWizard[i]["inventionId"] + "&c=" + this.contactId + "' class='topbar tbnext' target = '_self'> " + invWizard[i]["wizardStep"] + "</a></td > </tr>";
            }
            intLastInventionID = invWizard[i]["inventionId"];
            intLastWiardID = invWizard[i]["wizardId"];
        }
        sTemplate += "</table>";
        $('#dvContactInventions').html(sTemplate);

    }

    getDocumentName(docTypeId) {
        let docName: string = '';

        for (var i = 0; i < this.configDocuments.docsList.length; i++) {
            if (this.configDocuments.docsList[i].id == docTypeId) {
                docName = this.configDocuments.docsList[i].name;
            }
        }

        if (docName == '') {
            for (var i = 0; i < this.configDocuments.stateDocsList.length; i++) {
                if (this.configDocuments.stateDocsList[i].id == docTypeId) {
                    docName = this.configDocuments.stateDocsList[i].name;
                }
            }
        }
        return docName;
    }

    get otherCountry(): boolean {
        if ((this.contactDetail.country.toLowerCase() == "united kingdom") || (this.contactDetail.country.toLowerCase() == "uk")
            || (this.contactDetail.country.toLowerCase() == "england") || (this.contactDetail.country.toLowerCase() == "great britain") || (this.contactDetail.country == "4")
            || (this.contactDetail.country.toLowerCase() == "ireland") || (this.contactDetail.country.toLowerCase() == "ire") || (this.contactDetail.country == "6")
            || (this.contactDetail.country.toLowerCase() == "aus") || (this.contactDetail.country.toLowerCase() == "australia") || (this.contactDetail.country == "3")
            || (this.contactDetail.country.toLowerCase() == "can") || (this.contactDetail.country.toLowerCase() == "canada") || (this.contactDetail.country == "2")
            || (this.contactDetail.country.toLowerCase() == "united states of america") || (this.contactDetail.country.toLowerCase() == "usa")
            || (this.contactDetail.country.toLowerCase() == "us") || (this.contactDetail.country.toLowerCase() == "united states") || (this.contactDetail.country.toLowerCase() == "america")
            || (this.contactDetail.country == "1") || ((this.contactDetail.country.trim() == "") || (isNullOrUndefined(this.contactDetail.country)))) {
            return false;
        }
        else
            return true;
    }

    async saveInvention(source: string) {
        //await this.loadContact();
        this._inventionService.getInventionByContactIdAsync(this.encryptedUser, this.contactId, this.clpUserId, "Plus")
            .then(res => {
                if (res)
                    this.inventionContactResponse = UtilityService.clone(res);

                if (this.inventionContactResponse) {
                    if (isNullOrUndefined(this.inventionContact))
                        this.inventionContact = UtilityService.clone(this.inventionContactResponse.inventionContact);
                    const ELEMENT_INVENTION_CONTACT: InventionContact[] = this.inventionContact;
                    if (this.inventionContact.length > 0) {
                        var invName = this.inventionContact.find(inv => inv.inventionName.toLowerCase() == (source == 'I' ? $("#inventionName").val().toLowerCase() : $("#inventionContName").val().toLowerCase()));
                        if (invName) {
                            this.isBIPClient = invName.isBIPClient ? invName.isBIPClient : false;
                            this.isSubClient = invName.isSubClient ? invName.isSubClient : false;
                            this.exInventionName = invName.inventionName;
                            this.exInventionId = invName.inventionId;
                        }
                    }
                    this.dataSourceInvention = new MatTableDataSource(ELEMENT_INVENTION_CONTACT);
                    this.applyInventionFilter(this.searchInvention.value);
                    this.saveInventionAfterCheck();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.isLoading = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    saveInventionAfterCheck() {
        $('#informMsg').text("");
        $('#informInventMsg').text("");

        if (this.chkContactList)
            this.inventionName = $('#inventionName').val();
        else
            this.inventionName = $('#inventionContName').val();
        if (!this.inventionName)
            return;
        if (this.userNMIKeys.nmiKey.trim() == "" || !this.userNMIKeys.nmiKey) {
            $('#informMsg').text("NMI Key is not configured for your account.");
            $('#informInventMsg').text("NMI Key is not configured for your account.");
            return;
        }
        if (!this.officeList) {
            $('#informMsg').text("Office is not configured for your account.");
            $('#informInventMsg').text("Office is not configured for your account.");
            return;
        }
        if (this.isBIPClient || this.isSubClient) {
            if ($('#inventionContName').val().toLowerCase() == this.exInventionName.toLowerCase() && !isNullOrUndefined(this.exInventionName)) {
                $('#informInventMsg').text("An invention with this name already exists in the old system.");
                return;
            }
        }
        if (+this.contractListForm.controls.clientCountry.value == 399) {
            if (this.otherCountry && ((this.contactDetail.country.trim() == "") || (isNullOrUndefined(this.contactDetail.country)))) {
                $('#informMsg').text("Please update Country in SalesOptima contact page.");
                $('#informInventMsg').text("Please update Country in SalesOptima contact page.");
                return;
            }
        }
        if (this.otherCountry && +this.contractListForm.controls.clientCountry.value < 399) {
            $('#informMsg').text("Please select Other as Country option or update Country in SalesOptima contact page.");
            $('#informInventMsg').text("Please select Other as Country option or update Country in SalesOptima contact page.");
            return;
        }
        if (!this.otherCountry && +this.contractListForm.controls.clientCountry.value == 399) {
            $('#informMsg').text("You can't create Invention in Other Country option or update Country in SalesOptima contact page.");
            $('#informInventMsg').text("You can't create Invention in Other Country option or update Country in SalesOptima contact page.");
            return;
        }
        if ((this.contactDetail.country.toLowerCase() == "united kingdom") || (this.contactDetail.country.toLowerCase() == "uk")
            || (this.contactDetail.country.toLowerCase() == "england") || (this.contactDetail.country.toLowerCase() == "great britain") || (this.contactDetail.country == "4"))
            this.contactDetail.country = "4";
        else if ((this.contactDetail.country.toLowerCase() == "ireland") || (this.contactDetail.country.toLowerCase() == "ire") || (this.contactDetail.country == "6"))
            this.contactDetail.country = "6";
        else if ((this.contactDetail.country.toLowerCase() == "aus") || (this.contactDetail.country.toLowerCase() == "australia") || (this.contactDetail.country == "3"))
            this.contactDetail.country = "3";
        else if ((this.contactDetail.country.toLowerCase() == "can") || (this.contactDetail.country.toLowerCase() == "canada") || (this.contactDetail.country == "2"))
            this.contactDetail.country = "2";
        else if ((this.contactDetail.country.toLowerCase() == "united states of america") || (this.contactDetail.country.toLowerCase() == "usa")
            || (this.contactDetail.country.toLowerCase() == "us") || (this.contactDetail.country.toLowerCase() == "united states") || (this.contactDetail.country.toLowerCase() == "america")
            || (this.contactDetail.country == "1") || ((this.contactDetail.country.trim() == "") || (isNullOrUndefined(this.contactDetail.country))))
            this.contactDetail.country = "1";
        else
            this.contactDetail.country = "399";

        this.validateState = this.stateList.find(st => st.code.toLowerCase() == this.contactDetail.state.toLowerCase());
        if (!isNullOrUndefined(this.validateState) || (this.contactDetail.country == "4") || (this.contactDetail.country == "6")
            || (this.contactDetail.country == "3") || (this.contactDetail.country == "399") || (this.contactDetail.country == "1")) {
            let countryName = this.contactDetail.country;

            this.filterStateList(Number(this.contactDetail.country)).then(async res => {
                this.filteredStateList = res;
                if (!isNullOrUndefined(this.filteredStateList)) {
                    for (let i = 0; i < this.filteredStateList.length; i++) {
                        if (this.filteredStateList[i].code.toLowerCase() == this.contactDetail.state.toLowerCase()) {
                            this.checkState = this.contactDetail.state;
                        }
                    }
                    if (this.checkState.trim() == "" && Number(this.contactDetail.country) < 3) {
                        if (this.contactDetail.state != "") {
                            $('#informMsg').text("Please update the correct State Code in your SalesOptima contact page. \n" + "Current State Code: " + this.contactDetail.state);
                            $('#informInventMsg').text("Please update the correct State Code in your SalesOptima contact page. \n" + "Current State Code: " + this.contactDetail.state);
                        }
                        else {
                            $('#informMsg').text("Please update the State Code in your SalesOptima contact page.");
                            $('#informInventMsg').text("Please update the State Code in your SalesOptima contact page.");
                        }
                        return;
                    }
                    else {
                        this.copyValuesToDataObject();
                        if (isNullOrUndefined(this.inventionDetails.InventionName) || this.inventionDetails.InventionName == '') {
                            if (this.chkContactList)
                                this.inventionDetails.InventionName = $('#inventionName').val();
                            else
                                this.inventionDetails.InventionName = $('#inventionContName').val();
                        }
                        this._inventionService.createInventionAsync(this.encryptedUser, this.officeNum, this.clpUserId, this.inventionDetails)
                            .then(res => {
                                if (res) {
                                    this.inventionResponse = UtilityService.clone(res);
                                    if (this.inventionResponse) {
                                        this.inventionDetails = UtilityService.clone(this.inventionResponse.inventionDetails);
                                        if (this.inventionDetails.InventionId == -1) {
                                            if (this.inventionDetails.IHProductId > 0 && this.inventionDetails.IHProductId < 9) {
                                                this.isInventionExist = true;
                                                if (this.chkContactList)
                                                    $('#informMsg').text("An invention with this name already exists. Please select contract type and then create contract.");
                                                else
                                                    $('#informInventMsg').text("An invention with this name already exists. Please select contract type and then create contract.");
                                            }
                                            else {
                                                this.isInventionExist = false;
                                                if (this.chkContactList)
                                                    $('#informMsg').text("An invention with this name already exists.");
                                                else
                                                    $('#informInventMsg').text("An invention with this name already exists.");
                                            }
                                        }
                                        else {
                                            if (this.chkContactList)
                                                $('#modalContactList').modal('hide');
                                            else
                                                $('#modalInventionList').modal('hide');
                                            this.inventionId = this.inventionDetails.InventionId;
                                            this.isClientRemote = this.contractListForm.controls.isClientRemote.value ? this.contractListForm.controls.isClientRemote.value : this.contractListForm.controls.isContractInvRemote.value ? this.contractListForm.controls.isContractInvRemote.value : false;
                                            this.countryID = this.contractListForm.controls.clientCountry.value ? this.contractListForm.controls.clientCountry.value : 1;
                                            this._wizardService.createContractSessionAsync(this.encryptedUser, this.inventionId, this.contactId, 11, false, 0, this.isClientRemote, this.clpUserId, this.isSecondContract, this.countryID)
                                                .then(res => {
                                                    if (res) {
                                                        this.contractSessionResponse = UtilityService.clone(res);
                                                        if (this.contractSessionResponse) {
                                                            this.contractSessionId = this.contractSessionResponse.contractSessionId;
                                                            this.UpdateContractActionlog(this.contractSessionId, "");
                                                        }
                                                    }
                                                }).catch((err: HttpErrorResponse) => {
                                                    this._utilityService.handleErrorResponse(err);
                                                });
                                        }
                                    }
                                }
                            }).catch((err: HttpErrorResponse) => {
                                this._utilityService.handleErrorResponse(err);
                            });
                    }
                }
            });
        }
        else {
            $('#informMsg').text("Please update the State Code in your SalesOptima contact page.");
            $('#informInventMsg').text("Please update the State Code in your SalesOptima contact page.");
            return;
        }
    }

    sendToContract() {
        $('#modalInventionList').modal('hide');
        if (this.encryptedUser) {
            if (!isNullOrUndefined(this.contractSession)) {
                if (this.contractSession.isClientRemote) {
                    this._router.navigate(['/patent-plus-contract-remote', this.contactId, this.inventionId, this.contractSessionId, this.clpUserIdCount > 1 ? this.clpUserId : 0], {
                        queryParams: { w: 1, 'i': this.inventionId, 'c': this.contactId, 'cs': this.contractSessionId, 'rd': this.clpUserIdCount > 1 ? this.clpUserId : 0, 'r': this.encryptedUser }
                    });

                } else {
                    this._router.navigate(['/patent-plus-contract', this.contactId, this.inventionId, this.contractSessionId, this.clpUserIdCount > 1 ? this.clpUserId : 0], {
                        queryParams: { w: 1, 'i': this.inventionId, 'c': this.contactId, 'cs': this.contractSessionId, 'rd': this.clpUserIdCount > 1 ? this.clpUserId : 0, 'r': this.encryptedUser }
                    });
                }
            } else {
                if (this.contractSessionId > 0 && !isNullOrUndefined(this.contractSessionId)) {
                    this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
                        .then(res => {
                            if (res) {
                                this.contractSession = UtilityService.clone(res);
                                if (!isNullOrUndefined(this.contractSession) && this.contractSession.isClientRemote) {
                                    this._router.navigate(['/patent-plus-contract-remote', this.contactId, this.inventionId, this.contractSessionId, this.clpUserIdCount > 1 ? this.clpUserId : 0], {
                                        queryParams: { w: 1, 'i': this.inventionId, 'c': this.contactId, 'cs': this.contractSessionId, 'rd': this.clpUserIdCount > 1 ? this.clpUserId : 0, 'r': this.encryptedUser }
                                    });
                                } else {
                                    this._router.navigate(['/patent-plus-contract', this.contactId, this.inventionId, this.contractSessionId, this.clpUserIdCount > 1 ? this.clpUserId : 0], {
                                        queryParams: { w: 1, 'i': this.inventionId, 'c': this.contactId, 'cs': this.contractSessionId, 'rd': this.clpUserIdCount > 1 ? this.clpUserId : 0, 'r': this.encryptedUser }
                                    });
                                }
                            }
                        })
                        .catch((err: HttpErrorResponse) => {
                            this._utilityService.handleErrorResponse(err);
                        });
                }
            }
        }
    }

    createContract() {
        $('#informMsg').text('');
        $('#informInventMsg').text('');
        if (this.userNMIKeys.nmiKey.trim() == "" || !this.userNMIKeys.nmiKey) {
            $('#informContMsg').text("NMI Key is not configured for your account.");
            return;
        }
        if (!this.officeList) {
            $('#informContMsg').text("Office is not configured for your account.");
            return;
        }
        if (isNullOrUndefined(this.contactId)) {
            this._route.paramMap.subscribe(async params => {
                if (params.has('contact')) {
                    this.contactId = +params.get('contact');
                }
            })
        }
        this._contactService.getContactAsync(this.encryptedUser, this.contactId)
            .then(async (result: ContactResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.contactResponse = UtilityService.clone(result);
                        if (this.contactResponse) {
                            this.contactDetail = UtilityService.clone(this.contactResponse.contactDetails);
                            if (+this.contractListForm.controls.clientCountry.value == 399) {
                                if (this.otherCountry && ((this.contactDetail.country.trim() == "") || (isNullOrUndefined(this.contactDetail.country)))) {
                                    $('#informContMsg').text("Please update Country in SalesOptima contact page.");
                                    return;
                                }
                            }
                            if (this.otherCountry && +this.contractListForm.controls.clientCountry.value < 399) {
                                $('#informContMsg').text("Please select Other as Country option or update Country in SalesOptima contact page.");
                                return;
                            }
                            if (!this.otherCountry && +this.contractListForm.controls.clientCountry.value == 399) {
                                $('#informContMsg').text("You can't create Contract in Other Country option.");
                                return;
                            }
                            else {
                                if ((this.contactDetail.country.toLowerCase() == "united kingdom") || (this.contactDetail.country.toLowerCase() == "uk")
                                    || (this.contactDetail.country.toLowerCase() == "england") || (this.contactDetail.country.toLowerCase() == "great britain") || (this.contactDetail.country == "4"))
                                    this.contactDetail.country = "4";
                                else if ((this.contactDetail.country.toLowerCase() == "ireland") || (this.contactDetail.country.toLowerCase() == "ire") || (this.contactDetail.country == "6"))
                                    this.contactDetail.country = "6";
                                else if ((this.contactDetail.country.toLowerCase() == "aus") || (this.contactDetail.country.toLowerCase() == "australia") || (this.contactDetail.country == "3"))
                                    this.contactDetail.country = "3";
                                else if ((this.contactDetail.country.toLowerCase() == "can") || (this.contactDetail.country.toLowerCase() == "canada") || (this.contactDetail.country == "2"))
                                    this.contactDetail.country = "2";
                                else if ((this.contactDetail.country.toLowerCase() == "united states of america") || (this.contactDetail.country.toLowerCase() == "usa")
                                    || (this.contactDetail.country.toLowerCase() == "us") || (this.contactDetail.country.toLowerCase() == "united states") || (this.contactDetail.country.toLowerCase() == "america")
                                    || (this.contactDetail.country == "1") || ((this.contactDetail.country.trim() == "") || (isNullOrUndefined(this.contactDetail.country))))
                                    this.contactDetail.country = "1";
                                else
                                    this.contactDetail.country = "399";

                                this.validateState = this.stateList.find(st => st.code.toLowerCase() == this.contactDetail.state.toLowerCase());
                                if ((!isNullOrUndefined(this.validateState) || (this.contactDetail.country == "4") || (this.contactDetail.country == "6")
                                    || (this.contactDetail.country == "3") || (this.contactDetail.country == "399") || (this.contactDetail.country == "1"))) {
                                    let countryName = this.contactDetail.country;

                                    this.filterStateList(Number(this.contactDetail.country)).then(async res => {
                                        this.filteredStateList = res;
                                        if (!isNullOrUndefined(this.filteredStateList)) {
                                            for (let i = 0; i < this.filteredStateList.length; i++) {
                                                if (this.filteredStateList[i].code.toLowerCase() == this.contactDetail.state.toLowerCase()) {
                                                    this.checkState = this.contactDetail.state;
                                                }
                                            }
                                            if (this.checkState.trim() == "" && Number(this.contactDetail.country) < 3) {
                                                if (this.contactDetail.state != "")
                                                    $('#informContMsg').text("Please update the correct State Code in your SalesOptima contact page. \n" + "Current State Code: " + this.contactDetail.state);
                                                else
                                                    $('#informContMsg').text("Please update the State Code in your SalesOptima contact page.");
                                                return;
                                            }
                                            else {
                                                for (var i = 0; i < this.productDetails.length; i++) {
                                                    if (this.productDetails[i].productId == this.productId) {
                                                        if (this.productDetails[i].isExists) {
                                                            this.isProductExists = true; this.isContExists = true; this.isSecondContract = true;
                                                        }
                                                        else {
                                                            this.isProductExists = false; this.isContExists = false; this.isSecondContract = true;
                                                        }
                                                        break;
                                                    }
                                                }

                                                this.isContractRemote = this.contractListForm.controls.isContractRemote.value ? this.contractListForm.controls.isContractRemote.value : false;
                                                this.countryID = this.contractListForm.controls.clientCountry.value ? this.contractListForm.controls.clientCountry.value : 1;
                                                if (!this.isProductExists) {
                                                    if ((isNullOrUndefined(this.exInventionId) || (this.exInventionId <= 0)) && (this.isBIPClient || this.isSubClient)) {
                                                        this.inventionName = $("#contractInvention option:selected").text();
                                                        this.copyValuesToDataObject();

                                                        if (isNullOrUndefined(this.inventionDetails.InventionName) || (this.inventionDetails.InventionName == ''))
                                                            this.inventionDetails.InventionName = this.inventionName;
                                                        this._inventionService.createInventionAsync(this.encryptedUser, this.officeNum, this.clpUserId, this.inventionDetails)
                                                            .then(res => {
                                                                if (res) {
                                                                    this.inventionResponse = UtilityService.clone(res);
                                                                    if (this.inventionResponse) {
                                                                        this.inventionDetails = UtilityService.clone(this.inventionResponse.inventionDetails);
                                                                        this.inventionId = this.inventionDetails.InventionId;
                                                                        this._wizardService.createContractSessionAsync(this.encryptedUser, this.inventionId, this.contactId, this.productId, false, 0, this.isContractRemote, this.clpUserId, this.isSecondContract, this.countryID)
                                                                            .then(res => {
                                                                                if (res) {
                                                                                    this.contractSessionResponse = UtilityService.clone(res);
                                                                                    if (this.contractSessionResponse) {
                                                                                        this.contractSessionId = this.contractSessionResponse.contractSessionId;

                                                                                        $('#modalInventionList').modal('hide');
                                                                                        this.UpdateContractActionlog(this.contractSessionId, "");
                                                                                    }
                                                                                }
                                                                            }).catch((err: HttpErrorResponse) => {
                                                                                this._utilityService.handleErrorResponse(err);
                                                                            });

                                                                    }
                                                                }
                                                            }).catch((err: HttpErrorResponse) => {
                                                                this._utilityService.handleErrorResponse(err);
                                                            });
                                                    }
                                                    else {
                                                        if (!isNullOrUndefined(this.inventionDetails) && this.inventionDetails.IHProductId > 0 && this.inventionDetails.IHProductId < 9)
                                                            this.inventionId = this.inventionDetails.IHInventionId;
                                                        this._wizardService.createContractSessionAsync(this.encryptedUser, this.inventionId, this.contactId, this.productId, false, 0, this.isContractRemote, this.clpUserId, this.isSecondContract, this.countryID)
                                                            .then(res => {
                                                                if (res) {
                                                                    this.contractSessionResponse = UtilityService.clone(res);
                                                                    if (this.contractSessionResponse) {
                                                                        this.contractSessionId = this.contractSessionResponse.contractSessionId;

                                                                        $('#modalInventionList').modal('hide');
                                                                        this.UpdateContractActionlog(this.contractSessionId, "");
                                                                    }
                                                                }
                                                            }).catch((err: HttpErrorResponse) => {
                                                                this._utilityService.handleErrorResponse(err);
                                                            });
                                                    }
                                                }
                                            }
                                        }
                                    });
                                }
                                else {
                                    $('#informContMsg').text("Please update the State Code in your SalesOptima contact page.");
                                    return;
                                }
                            }
                        }

                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    showContracts(contactId, inventionId, contractSessionId, contractStatus) {
        $('#informContMsg').text('');
        this.isInventionExist = false;
        if (contractSessionId > 0 && !isNullOrUndefined(contractSessionId)) {
            this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, contractSessionId)
                .then(res => {
                    if (res) {
                        this.contractSession = UtilityService.clone(res);
                        this.countryID = this.contractSession.CountryID;
                        this.contractListForm.patchValue({
                            contract: 1,
                            contractInvention: inventionId,
                            contractType: 11,
                            clientCountry: this.countryID ? this.countryID : 1
                        });


                        this.contactId = contactId;
                        this.contractSessionId = contractSessionId;
                        this.inventionId = inventionId;

                        if (inventionId > 0) {
                            this.isNewInvention = false;
                            this.loadContractSession(inventionId, '', contractStatus);
                        }
                        else
                            this.isNewInvention = true;

                        this.loadInventionByContactId('');

                        $('#modalInventionList').modal('show');
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    deleteContract(contactId, inventionId, contractSessionId, contractStatus) {
        $('#modalDeleteContract').modal('show');
        this.deletecontractSessionId = contractSessionId;
    }

    deleteConfirmation(val) {
        if (val == 'Yes') {
            this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.deletecontractSessionId)
                .then(res => {
                    if (res) {
                        this.contractSession = UtilityService.clone(res);
                        this.contractSession.ContractSessionId = this.deletecontractSessionId;
                        this.contractSession.isDeleted = true;
                        this._contractSessionService.createContactSessionAsync(this.encryptedUser, this.contractSession)
                            .then(res => {
                                if (res) {
                                    this.contractSession = UtilityService.clone(res);
                                    this.loadContractDetails();
                                    $('#modalDeleteContract').modal('hide');
                                    this.openSnackBar("Contract deleted successfully.", "")
                                }
                            }).catch((err: HttpErrorResponse) => {
                                this._utilityService.handleErrorResponse(err);
                            });
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else
            $('#modalDeleteContract').modal('hide');
    }

    validateProduct() {
        this.productId = this.contractListForm.controls.contractType.value;
        if (this.productDetails && this.contractSessionListResponse) {
            for (var p = 0; p < this.productDetails.length; p++) {
                this.productDetails[p].isExists = false;
            }

            for (var i = 0; i < this.productDetails.length; i++) {
                for (var j = 0; j < this.contractSessionListResponse.contractSession.length; j++) {
                    if (this.productDetails[i].productId == this.contractSessionListResponse.contractSession[j].productId && this.contractSessionListResponse.contractSession[j].status != 2
                        && !this.contractSessionListResponse.contractSession[j].isDeleted && this.contractSessionListResponse.contractSession[j].inventionId == +this.contractListForm.controls.contractInvention.value)
                        this.productDetails[i].isExists = true;
                }
            }

            for (var s = 0; s < this.contractSessionListResponse.contractSession.length; s++) {
                if (this.productId == this.contractSessionListResponse.contractSession[s].productId && this.contractSessionListResponse.contractSession[s].status != 2
                    && !this.contractSessionListResponse.contractSession[s].isDeleted)
                    this.contractSessionId = this.contractSessionListResponse.contractSession[s].ContractSessionId;
            }
        }
        if (this.productDetails) {
            //for (var i = 0; i < this.productDetails.length; i++) {
            //    if (this.isBIPClient) {
            //        this.productDetails[0].isExists = true;
            //        this.productDetails[1].isExists = true;
            //    }
            //    if (this.isSubClient) {
            //        this.productDetails[2].isExists = true;
            //        this.productDetails[6].isExists = true;
            //        if (this.productDetails.length > 7)
            //            this.productDetails[7].isExists = true;
            //    }
            //}

            if ((this.isBIPClient && this.productId <= 2) || (this.isSubClient && (this.productId == 3 || (this.productId >= 7 || this.productId <= 10)))) {
                this.oldInventHelp = " in the old system";
                this.isOldInventHelp = true;
                this.isProductExists = true;
                this.isContExists = true;
            }
            else {
                this.oldInventHelp = "";
                this.isOldInventHelp = false;
                this.isProductExists = false;
                this.isContExists = false;
            }
        }
    }

    async changeInventionContact(inventionId) {
        $('#informMsg').text('');
        $('#informInventMsg').text('');
        $('#informContMsg').text('');
        this.isInventionExist = false;
        if (this.contractListForm.controls.contractInvention.value == "-1") {
            this.isNewInvention = true;
            this.isSecondContract = false;
        }
        else
            this.isNewInvention = false;
        if (!this.isNewInvention) {
            await this.loadContractSession(inventionId, 'contract');
            this.inventionId = inventionId;
            this.contractListForm.patchValue({
                clientCountry: this.countryID
            });
        }
        else {
            this.loadInventionByContactId(() => { this.validateProduct(); });
            this.loadContact();
        }
    }

    changeInventionName() {
        this.isInventionExist = false;
        $('#informMsg').text('');
        $('#informInventMsg').text('');
    }

    private async loadContractSession(inventionId, source, contractStatus?: string) {
        if (inventionId > 0 && !isNullOrUndefined(inventionId)) {
            await this._contractSessionService.getContactSessionAsync(this.encryptedUser, inventionId)
                .then(res => {
                    if (res) {
                        this.contractSessionListResponse = UtilityService.clone(res);
                        this.inventionId = inventionId;
                        if (!isNullOrUndefined(this.contractSessionListResponse)) {
                            if (this.contractSessionListResponse.contractSession.length > 0) {
                                this.contractSession = this.contractSessionListResponse.contractSession[0];
                                let firstContractsessionID: number = this.contractSessionListResponse.contractSession[0].ContractSessionId;
                                let countryID: number = this.contractSessionListResponse.contractSession[0].CountryID;
                                let inventionName: string = this.contractSessionListResponse.contractSession[0].inventionName;
                                if ((this.contractSessionListResponse.contractSession.length > 1 && this.contractSessionId != firstContractsessionID) || (inventionName.toLowerCase() == this.exInventionName.toLowerCase() && (this.isBIPClient || this.isSubClient)))
                                    this.isSecondContract = true;
                                else
                                    this.isSecondContract = false;
                                if (source == 'contract' || contractStatus == "Cancelled") {
                                    if (!isNullOrUndefined(inventionName) && inventionName.toLowerCase() == $("#contractInvention option:selected").text().toLowerCase()) {
                                        this.countryID = countryID;
                                    }
                                    else {
                                        this.countryID = 1;
                                    }
                                }
                            }
                            this.loadInventionByContactId(() => { this.validateProduct(); });
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else
            this.loadInventionByContactId(() => { this.validateProduct(); });
    }

    private async loadUserNMIKeys() {
        await this._configMasterService.getUserNMIKeysAsync(this.encryptedUser, this.clpUserId)
            .then(res => {
                if (res) {
                    this.userNMIKeys = UtilityService.clone(res);

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    resetDateFilter() {
        const ELEMENT_DATA: ContractDetails[] = this.contractDetails;
        this.dataSource = new MatTableDataSource(ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        if (localStorage.getItem('contractList_PageSize')) {
            let pageSizeVal: string = "";
            pageSizeVal = localStorage.getItem('contractList_PageSize');
            this.paginator.pageSize = parseInt(pageSizeVal);
        } else
            this.paginator.pageSize = 5;
        this.fromInput.value = '';
        this.toInput.value = '';
        this.search.value = "";
    }

    dateRangeFilter() {
        var pipe = new DatePipe("en");
        var fromDate = $("#fromDate").val();
        var toDate = $("#toDate").val();

        if (toDate && fromDate) {
            fromDate = new Date(fromDate);
            toDate = new Date(toDate);
            if (toDate >= fromDate) {
                const ELEMENT_DATA: ContractDetails[] = this.contractDetails;
                this.dataSource = new MatTableDataSource(ELEMENT_DATA);
                var filteredArray: ContractDetails[] = [];
                this.dataSource.data.filter(e => {
                    if (fromDate && toDate) {
                        if (new Date(e.lastUpdatedDate) >= fromDate && (new Date(e.lastUpdatedDate) <= toDate))
                            filteredArray.push(e);
                    }
                });
                this.dataSource = new MatTableDataSource(filteredArray);
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;
                this.dataSource.paginator.firstPage();
                if (localStorage.getItem('contractList_PageSize')) {
                    let pageSizeVal: string = "";
                    pageSizeVal = localStorage.getItem('contractList_PageSize');
                    this.paginator.pageSize = parseInt(pageSizeVal);
                } else
                    this.paginator.pageSize = 5;

            }
            else {
                this.openSnackBar("Please specify valid date range", "");
            }
        }

    }

    applyInventionFilter(filterValue: string) {
        this.dataSourceInvention.filter = filterValue.trim().toLowerCase();
    }

    applyContactFilter(filterValue: string) {
        if (filterValue.length >= 3) {
            this.searchContactText = filterValue;
            this.loadContactList();
        }
        else if (filterValue.length == 0) {
            this.searchContactText = "NoSearch";
            this.loadContactList();
        }
    }

    loadContactList() {
        this._contactService.getContactSearchListAsync(this.encryptedUser, this.searchContactText, this.clpUserId)
            .then(res => {
                if (res)
                    this.contactListResponse = UtilityService.clone(res);

                if (this.contactListResponse) {
                    this.contactDetails = UtilityService.clone(this.contactListResponse.contactDetails);
                    const ELEMENT_DATA_CONTACT: ContactDetails[] = this.contactDetails;
                    this.dataSourceContact = new MatTableDataSource(ELEMENT_DATA_CONTACT);
                    this.dataSourceContact.sort = this.sortContact;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.isLoading = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    loadInventionByContactId(callback) {
        this._inventionService.getInventionByContactIdAsync(this.encryptedUser, this.contactId, this.clpUserId, "Plus")
            .then(res => {
                if (res)
                    this.inventionContactResponse = UtilityService.clone(res);

                if (this.inventionContactResponse) {
                    this.inventionContact = UtilityService.clone(this.inventionContactResponse.inventionContact);
                    const ELEMENT_INVENTION_CONTACT: InventionContact[] = this.inventionContact;
                    if (this.inventionContact.length > 0) {
                        var invName = this.inventionContact.find(inv => inv.inventionName.toLowerCase() == $("#contractInvention option:selected").text().toLowerCase());
                        if (invName) {
                            this.isNewInvention = false;
                            this.isBIPClient = invName.isBIPClient ? invName.isBIPClient : false;
                            this.isSubClient = invName.isSubClient ? invName.isSubClient : false;
                            this.exInventionName = invName.inventionName;
                            this.exInventionId = invName.inventionId;

                            this.isFirstOnExisting = ((this.isBIPClient || this.isSubClient) && Number(this.inventionId) == 0) ? true : false;
                            //if (this.productDetails) {
                            //    for (var i = 0; i < this.productDetails.length; i++) {
                            //        if (this.isBIPClient) {
                            //            this.productDetails[0].isExists = true;
                            //            this.productDetails[1].isExists = true;
                            //        }
                            //        if (this.isSubClient) {
                            //            this.productDetails[2].isExists = true;
                            //            this.productDetails[6].isExists = true;
                            //            if (this.productDetails.length > 7)
                            //                this.productDetails[7].isExists = true;
                            //        }
                            //    }
                            //}
                        }
                        else {
                            this.isNewInvention = true;
                            this.isSecondContract = false;
                        }
                    }
                    else {
                        this.contractListForm.patchValue({
                            contractInvention: '-1'
                        });
                        this.isNewInvention = true;
                        this.isSecondContract = false;
                    }
                    this.dataSourceInvention = new MatTableDataSource(ELEMENT_INVENTION_CONTACT);
                    this.applyInventionFilter(this.searchInvention.value);
                    if (callback != '')
                        callback();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.isLoading = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    tblColumnSorted(e) {
        if (e.sorts.length > 0) {
            this._sortCol = e.sorts[0].prop;
            this._sortDir = e.sorts[0].dir;
            localStorage.setItem('contracts_SortCol', this._sortCol);
            localStorage.setItem('contracts_SortDir', this._sortDir);
        }
    }

    public handlePage(e: any) {
        localStorage.setItem('contractList_PageSize', e.pageSize);
    }

    columns = [
        { prop: 'firstname', name: 'firstname' },
        { prop: 'homephone', name: 'homephone' },
        { prop: 'workphone', name: 'workphone' },
        { prop: 'mobile', name: 'mobile' },
        { prop: 'email', name: 'email' },
    ];

    getRowClass = (row) => {
        if (row.status != "SUCCESS") {
            return {
                'failure': true
            }
        }
    }

    showContactList() {
        this.contractListForm.patchValue({
            contractInvention: -1,
            clientCountry: 1
        });
        this.changeInventionContact(-1)
        //this.contractListForm.patchValue({
        //    clientCountry: 1
        //});
        this.dataSourceInvention = null;
        this.highlightedRows = [];
        this.isContactSelected = false;
        this.isInventionExist = false;
        if (this.contactIdParam == 0) {
            $('#modalContactList').modal('show');
            this.chkContactList = true;
        }
        else {
            $('#modalInventionList').modal('show');
            this.chkContactList = false;
            //$('#inventionContName').val(this.contactDetail.lastname + ' Invention');
        }
    }

    hideContactList() {
        if (this.contactId == 0)
            $('#modalContactList').modal('hide');
        else
            $('#modalInventionList').modal('hide');
    }

    private async loadContractDetails() {
        this.isLoading = true;
        let encryptedUser: string = '';

        this._route.paramMap.subscribe(async params => {
            if (params.has('contact')) {
                this.contactId = +params.get('contact');
                this.contactIdParam = +params.get('contact');

                if (params.has('clpuserid')) {
                    this.clpUserId = +params.get('clpuserid');

                    this.loadUserNMIKeys();
                    this.loadOffice();

                    if (this.contactId == 0)
                        this.loadContactList();
                    else {
                        this.loadInventionByContactId('');
                        this.loadContact();
                    }
                    await this._contractSessionService.getContractDetailsAsync(encryptedUser, this.clpUserId, this.contactId, "Plus")
                        .subscribe(res => {
                            if (res)
                                this.contractDetailsResponse = UtilityService.clone(res);

                            if (this.contractDetailsResponse) {
                                this.contractDetails = UtilityService.clone(this.contractDetailsResponse.contractDetails);

                                if (this.contractDetails) {
                                    this.currentUser = UtilityService.clone(this.contractDetailsResponse.currentUser);
                                    const ELEMENT_DATA: ContractDetails[] = this.contractDetails;
                                    var result = ELEMENT_DATA.reduce((acc, o) => (acc[o.clpUserId] = (acc[o.clpUserId] || 0) + 1, acc), {});
                                    this.clpUserIdCount = Object.keys(result).length
                                    if (localStorage.getItem('contractList_PageSize')) {
                                        let pageSizeVal: string = "";
                                        pageSizeVal = localStorage.getItem('contractList_PageSize');
                                        this.paginator.pageSize = parseInt(pageSizeVal);
                                    } else
                                        this.paginator.pageSize = 5;
                                    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
                                    this.dataSource.sort = this.sort;
                                    this.dataSource.paginator = this.paginator;
                                    this.applyFilter(this.search.value);
                                }
                                else
                                    this.dataSource = new MatTableDataSource([]);
                                this._cdref.detectChanges();
                                this.isLoading = false;
                            }
                            else {
                                this.isLoading = false;
                            }
                        }, error => {
                            console.error(error);
                        });
                }
                else
                    console.log("no clpUserId");
            }
            else
                console.log("no contact");
        });
    }

    private async loadContact() {
        if (isNullOrUndefined(this.contactId)) {
            this._route.paramMap.subscribe(async params => {
                if (params.has('contact')) {
                    this.contactId = +params.get('contact');
                }
            })
        }
        await this._contactService.getContactAsync(this.encryptedUser, this.contactId)
            .then(async (result: ContactResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.contactResponse = UtilityService.clone(result);
                        if (this.contactResponse) {
                            this.contactDetail = UtilityService.clone(this.contactResponse.contactDetails);
                            this.inventorName = this.contactDetail.firstname + ' ' + this.contactDetail.lastname;
                            if (this.isNewInvention) {
                                $('#inventionContName').val(this.contactDetail.lastname + ' Invention');
                            }
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadOffice() {
        await this._officeService.getOfficeListAsync(this.encryptedUser, this.clpUserId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.officeListResponse = UtilityService.clone(res);
                        this.officeList = this.officeListResponse.officeList;
                    } else {
                        console.log("Office List result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }
    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            verticalPosition: 'top',
            horizontalPosition: 'right',
            duration: 5000,
        });
    }

    private copyValuesToDataObject() {
        let inventionDetails: InventionDetails = {
            InventionId: -1,
            InventionName: '',
            IsOriginalInventor: false,
            IsOriginalInventorNoExplain: '',
            HasPrototype: false,
            HasMedia: false,
            HasMediaAssist: '',
            InventionHistory: '',
            InventionAdvantage: '',
            InventionUse: '',
            InventionDescription: '',
            Headline: '',
            Tagline: '',
            Inspiration: '',
            Benefits: '',
            Features: '',
            SurveyQuestion: '',
            DomainSuggestions: '',
            I1CLPContactId: -1,
            I2CLPContactId: -1,
            DTCreated: new Date(),
            DTModified: new Date(),
            Age: 0,
            Occupation: '',
            BCM_Home: false,
            BCM_Cell: false,
            BCM_Email: false,
            Inventor2Present: false,
            MandatoryFormStage: -1,
            IsAgree: false,
            isROIEnable: false,
            i2FirstName: '',
            i2LastName: '',
            isCoInventor: false,
            InventionFulFill: '',
            Weights: '',
            Lengths: '',
            Width: '',
            Shape: '',
            MaterialsUsed: '',
            UniqueFeatures: '',
            IsNewProduct: false,
            ExplainModification: '',
            PossibleVariations: '',
            CompetitiveProducts: '',
            SpecificGroups: '',
            IHProductId: -1,
            IHInventionId: -1
        }
        this.inventionDetails = inventionDetails;
        this.inventionDetails.InventionName = this.inventionName;
        this.inventionDetails.I1CLPContactId = this.contactId;
    }

    private async fetchStateList() {
        await this._stateService.getStateList(this.encryptedUser)
            .then(async (result: State[]) => {
                this.stateList = UtilityService.clone(result);
                // await this.handleChangeCountry(this.defaultCountryId);
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async filterStateList(iCountryId: number): Promise<State[]> {
        const filteredRecords: State[] = this.stateList.filter(st => st.countryId == iCountryId);
        return await UtilityService.clone(filteredRecords);
    }

    async exportContractsDoc(contactId, inventionId, ContractSessionId, flag, contractStatus) {
        this.docTitle = 'Data';
        this.docContaint = 'Fetching data...';
        $('#modalExportDocument').modal('show');

        await this.GetGenerateContractDetails(ContractSessionId);
        this.showInvention(contactId, inventionId, ContractSessionId, flag, contractStatus);

        this.inventionId = inventionId; this.contactId = contactId;
        this.contractSessionId = ContractSessionId;
        this.loadAddendumServices();

    }
    exportSetValue(inventionId, contractStatus) {
        if ((contractStatus.startsWith('Completed') || contractStatus == 'Cancelled' || contractStatus.startsWith('Approved')) && this.isExecuted) {
            $('#modalExportDocument').modal('hide');
            $('#modalExportDocumentAzure').modal('show');
        }
        else {
            this.docTitle = 'Generate Documents';
            this.docContaint = 'Documents are being generated...';
            $('#modalExportDocumentAzure').modal('hide');
            this.dvSpinner = true;
            this.chkExpPDF = true;
            this._contractSessionService.getContactSessionAsync(this.encryptedUser, inventionId)
                .then(res => {
                    if (res) {
                        this.contractSessionListResponse = UtilityService.clone(res);
                        this.inventionId = inventionId;
                        this._inventionService.getBIPExistforInventionAsync(this.encryptedUser, this.inventionId)
                            .then(async (result: boolean) => {
                                if (result) {
                                    this.isBIPExist = UtilityService.clone(result);
                                }
                                else {
                                    this.isBIPExist = false;
                                }
                            })
                            .catch((err: HttpErrorResponse) => {
                                this._utilityService.handleErrorResponse(err);
                            });

                        let firstContractsessionID: number = this.contractSessionListResponse.contractSession[0].ContractSessionId;
                        let inventionName: string = this.contractSessionListResponse.contractSession[0].inventionName;
                        if ((this.contractSessionListResponse.contractSession.length > 1 && this.contractSessionId != firstContractsessionID) || (inventionName.toLowerCase() == this.exInventionName.toLowerCase() && (this.isBIPClient || this.isSubClient)))
                            this.isSecondContract = true;
                        else {
                            if (this.contractSessionListResponse.contractSession[0].IsSecondContract)
                                this.isSecondContract = this.contractSessionListResponse.contractSession[0].IsSecondContract;
                            else
                                this.isSecondContract = false;
                        }
                        let docIds: string = this.getDocumentTypeIds(inventionId);
                        if (Number.isNaN(+docIds.replace(/,/g, '').replace(/-/g, '')))
                            setTimeout(() => {
                                docIds = this.getDocumentTypeIds(inventionId);
                                this.generatePDF(docIds);
                            }, 2000);
                        else
                            this.generatePDF(docIds);
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    generatePDF(docIds: string) {
        this._documentService.getGetDocumentZipAsync(this.encryptedUser, docIds, this.inventionId, this.contactId, this.contractSessionId, "Plus")
            .then((result: any) => {
                if (result) {
                    let file = new Blob([result], { type: 'application/zip' });
                    let fileURL = URL.createObjectURL(file);
                    let fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    if (this.contactDetail)
                        fileLink.download = "ContractDocuments_" + this.contactDetail.firstname + this.contactDetail.lastname + ".zip";
                    else
                        fileLink.download = "ContractDocuments.zip";

                    fileLink.click();
                    this.dvSpinner = false;
                    this.chkExpPDF = false;
                    $('#modalExportDocument').modal('hide');
                } else {
                    console.log("exportToPDF.statusCode: Error Getting Data");
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
                $('#modalExportDocument').modal('hide');
                $('#modalExportDocumentAzure').modal('hide');
            });
    }

    checkExistState(StateId) {

        switch (StateId) {
            case 24: this.isStateExists = true;
                break;
            case 26: this.isStateExists = true;
                break;
            case 34: this.isStateExists = true;
                break;
            case 35: this.isStateExists = true;
                break;
            case 37: this.isStateExists = true;
                break;
            case 44: this.isStateExists = true;
                break;
            case 47: this.isStateExists = true;
                break;
            default: this.isStateExists = false;
                break;
        }

    }

    isROIForm() {
        if (this.navigationResponse) {
            if (!this.navigationResponse.navigation.isROIForm) {
                this.isROISubmitted = false;
            }
            else {
                // this.fetchMediaImagesList(-1);
                this.isROISubmitted = true;
            }
        }
    }

    private async ContractPaymentGet(inventionId, productId, ContractSessionId, contractStatus) {

        await this._billingService.getContractPaymentAsync(this.encryptedUser, inventionId, productId, ContractSessionId)
            .then(res => {
                if (res) {

                    if (res.statusCode == 0) {
                        this.ContractPaymentResponse = UtilityService.clone(res);
                        this.contractPayment = this.ContractPaymentResponse.contractPayment;
                        if (this.contractPayment.paymentOptionId == 1)
                            this.flgInstallment = false;
                        else
                            this.flgInstallment = true;
                        this.exportSetValue(inventionId, contractStatus);

                    } else {
                        console.log("Office List result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
        //callback();
    }

    private async loadDocumentType() {
        await this._documentService.getConfigDetailsAsync(this.encryptedUser)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.configDocumentsResponse = UtilityService.clone(res);
                        if (this.configDocumentsResponse) {
                            this.configDocuments = this.configDocumentsResponse.configDocuments;
                        }
                    }
                }
            })
    }


    private async loadProduct(productId, countryID) {
        this._productService.getProductAsync(this.encryptedUser, productId, countryID, "Plus")
            .then(async (result: ProductResponse) => {
                if (result) {
                    this.productResponse = UtilityService.clone(result);
                    if (this.productResponse) {
                        this.productDetail = UtilityService.clone(this.productResponse.productDetails);
                        this.productId = this.productDetail.productId;
                    } else {
                        console.log("Product result status code: " + result.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadNavigationWizard(inventionId, contractSessionId, contractStatus) {

        await this._navigationService.getNavigationWizardAsync(this.encryptedUser, inventionId, contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.navigationResponse = UtilityService.clone(res);
                        this.navigation = this.navigationResponse.navigation;
                        this.ContractPaymentGet(inventionId, this.contractSession.productId, contractSessionId, contractStatus);
                    } else {
                        console.log("Navigation Wizard result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadUserState(stateCode: string, countryID) {
        await this.filterUserStateList(stateCode).then(async res => {
            this.filterUserStateLst = res;
            if (this.filterUserStateLst[0]) {
                if (countryID < 3) {
                    this.isWaitingPeriod = this.filterUserStateLst[0].waitPeriod || false;
                    this.isWestern = this.filterUserStateLst[0].isWestern;
                    this.isWaitStateDoc = this.isWaitingPeriod;
                    this.isWaitStateExists = this.isWaitingPeriod;
                }
            }
        });
    }
    private async filterUserStateList(istateCode: string): Promise<State[]> {
        const filteredRecords: State[] = this.stateList.filter(st => st.code == istateCode);
        return await UtilityService.clone(filteredRecords);
    }

    private async loadAddendumServices() {
        await this._addendumService.AddendumServices_GetAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.addendumServicesResponse = UtilityService.clone(res);

                    } else {
                        console.log("Addendum services result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    async GetGenerateContractDetails(csId) {
        await this._documentService.getContractsAzureDetailsAsync(this.encryptedUser, csId)
            .then(res => {
                if (res)
                    this.gencontractDetailsResponse = UtilityService.clone(res);

                if (this.gencontractDetailsResponse) {
                    this.generateContractsAzure = UtilityService.clone(this.gencontractDetailsResponse.getGenerateContractsAzure);

                    if (this.generateContractsAzure) {
                        this.isExecuted = this.generateContractsAzure.find(rows => rows.filePath != '' && rows.productId > 0) ? true : false;
                        const ELEMENT_DATA: GenerateContractsAzure[] = this.generateContractsAzure;
                        this.dataSourceGenContractPopUp = new MatTableDataSource(ELEMENT_DATA.filter(rows => rows.filePath != '' && rows.productId > 0));
                        this.dataSourceGenContractPopUp.sort = this.sortDocPopUp;
                        this.generateContractsMedia = ELEMENT_DATA.filter(rows => rows.filePath == '' && rows.productId == 0);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    hideDocList() {
        $('#modalExportDocumentAzure').modal('hide');
    }

    hideFilesList() {
        $('#modalExportCompressFile').modal('hide');
    }

    downloadFile(fileName, containerName) {
        this.loading = true;
        this._documentService.getContractsAzureZipEncriptAsync(this.encryptedUser, fileName, containerName, "AllFiles", 0, false)
            .then(async (result: any) => {
                if (result) {
                    console.log('downloadFile-' + result);
                    let file = new Blob([result], { type: 'application/zip' });
                    let fileURL = URL.createObjectURL(file);
                    let fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.download = fileName;
                    fileLink.click();
                    this.loading = false;
                } else {
                    this.loading = false;
                    console.log("exportToZIP.statusCode: Error Getting Data");
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.loading = false;
                this._utilityService.handleErrorResponse(err);
            });

    }

    async getCompressedFiles(fileName: string, containerName: string, source: string) {
        if (source == 'popup')
            this.popLoading = true;
        else
            this.loading = true;
        this._documentService.getCompressedFileNamesAsync(this.encryptedUser, fileName, containerName, 0, false)
            .then(async (result: any) => {
                if (result) {
                    var str_array = result.split(',');
                    this.createListItem(fileName, str_array);
                    this.loading = false;
                    this.popLoading = false;
                } else {
                    this.loading = false;
                    this.popLoading = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.loading = false;
                this.popLoading = false;
                this._utilityService.handleErrorResponse(err);
            });

    }

    async playMedia(fileName: string) {
        let azureMedia = {} as AzureMedia;
        azureMedia.contractSessionId = this.contractSessionId;
        azureMedia.fileName = fileName;
        this._documentService.getROIVideoURL(azureMedia, this.encryptedUser)
            .then(async (url: any) => {
                if (url) {
                    window.open(url, '_blank');
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    createListItem(fileName: string, str_array: any): void {
        this.singalDownload = [];
        for (var i = 0; i < str_array.length; i++) {
            this.singalDownload.push({ zipName: fileName, fileName: str_array[i] });
        }
        const ELEMENT_DATA: ContractsSingalFile[] = UtilityService.clone(this.singalDownload);;
        this.dataSourceSingleFile = new MatTableDataSource(ELEMENT_DATA);
        //this.dataSourceSingleFile.sort = this.sortDoc;
        $('#modalExportCompressFile').modal('show');
    }
    downloadSingalFile(zipName, containerName, fileName) {
        this.pop2Loading = true;
        var fileExtensio = fileName.split('.').pop();
        this._documentService.getContractsAzureZipEncriptAsync(this.encryptedUser, zipName, containerName, fileName, 0, false)
            .then(async (result: any) => {
                if (result) {
                    if (fileExtensio.toLowerCase() == 'pdf') {
                        let file = new Blob([result], { type: 'application/pdf' });
                        window.open(URL.createObjectURL(file), '_blank')
                    }
                    else {
                        let file = new Blob([result]);
                        let fileURL = URL.createObjectURL(file);
                        let fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.download = fileName;
                        fileLink.click();
                    }
                    this.pop2Loading = false;
                    this.loading = false;
                    this.popLoading = false;
                }
                else {
                    this.pop2Loading = false;
                    this.loading = false;
                    this.popLoading = false;
                }
            }).catch((err: HttpErrorResponse) => {
                this.pop2Loading = false;
                this.loading = false;
                this.popLoading = false;
                this._utilityService.handleErrorResponse(err);
            });
    }


    async getmySOURL() {
        await this._appconfigService.getAppConfigValues(this.encryptedUser, ["mySOAPP", "PatentPlusRedirect", "ProductYCutOffDate", "InventHelp_CS_Site"])
            .then(async (result: any) => {
                var resultvalue = UtilityService.clone(result);
                this.mySoUrl = resultvalue.filter(i => i.configKey == "mySOAPP")[0];
                this.inventHelpURL = resultvalue.filter(i => i.configKey == "PatentPlusRedirect")[0];
                this.productYCutOffDate = resultvalue.filter(i => i.configKey == "ProductYCutOffDate")[0];
                this.inventHelp_CS_Site = resultvalue.filter(i => i.configKey == "InventHelp_CS_Site")[0];
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }
    async identifyUserRole() {
        await this.getmySOURL();
        let url = this.mySoUrl.configValue;
        let inventHelpUrlValue = this.inventHelpURL.configValue;
        this._route.queryParamMap.subscribe(params => {
            if (params.has('r')) {
                this.encryptedUser = params.get('r');
                this._userService.getAuthenticateR(this.encryptedUser)
                    .then(res => {
                        if (res) {
                            if (res.isvalid) {
                                this.loadContractDetails();
                                this.userResponse = UtilityService.clone(res);
                                console.log("Valid User");
                                this.permissionResponse = this.userResponse.user.clientServicesPermissions;
                                this.loadProductList();
                            }
                        } //else {
                        //    $(location).attr('href', url + "?ReturnUrl=" + encodeURIComponent(inventHelpUrlValue + "/corp-contract/" + this.contactId + "/" + this.contractSessionId + "&c=con&i=cl"));
                        //}
                    })
                    .catch((err: HttpErrorResponse) => {
                        console.log("Client side Error : " + err);
                        this._utilityService.handleErrorResponse(err);
                    });
            }
            //else {
            //    console.log('no r');
            //    $(location).attr('href', url + "?ReturnUrl=" + encodeURIComponent(inventHelpUrlValue + "/corp-contract/" + this.contactId + "/" + this.contractSessionId + "&c=con&i=cl"));
            //}
        });
    }
    getDocumentTypeIds(inventionId): string {
        let docIds: string = "";

        var state = this.stateList.find(st => st.code.toLowerCase() == this.contractSession.conSessnClientState.toLowerCase());
        let stateid: number = state != null ? state.id : -1;
        this.isROIForm();
        this.checkExistState(stateid);

        if (this.navigationResponse.navigation) {
            if (this.productDetail) {
                if (this.contractPayment) {
                    if (this.contractPayment.paymentOptionId == 1 || this.contractPayment.paymentOptionId == 0)
                        docIds += this.isWestern == false ? this.productDetail.eIHFullPaymentDoc : this.productDetail.eIWHFullPaymentDoc;
                    else if (this.contractPayment.paymentOptionId == 2)
                        docIds += this.isWestern == false ? this.productDetail.eIHInstallPaymentDoc : this.productDetail.eIWHInstallPaymentDoc;
                }
            }
            else {
                if (this.contractPayment) {
                    if (this.contractPayment.paymentOptionId == 1 || this.contractPayment.paymentOptionId == 0)
                        docIds += this.isWestern == false ? this.productDetails[0].eIHFullPaymentDoc : this.productDetails[0].eIWHFullPaymentDoc;
                    else if (this.contractPayment.paymentOptionId == 2)
                        docIds += this.isWestern == false ? this.productDetails[0].eIHInstallPaymentDoc : this.productDetails[0].eIWHInstallPaymentDoc;
                }
            }
            if (this.contractSession.USFeeConfirm == 2 || this.contractSession.CountryID == 2) {
                docIds = this.isWestern == true ? docIds.replace("32", "37") : docIds.replace("22", "37");
                docIds = docIds.replace(",3,", ",38,");
            }
            if (this.productId == 1 || this.productId == 2 || this.productId == 6 || this.productId == 11) {

                if (!this.navigationResponse.navigation.isNDADoc && this.contractSession.CountryID < 3) {
                    //If NDA is not signed then export Mandate doc only
                    docIds = this.productDetails[0].ihMandatoryDoc.replace("S", "0");
                }
                else {
                    if (!isNullOrUndefined(this.configDocuments)) {
                        var sateDocBeforeAfterNDA = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 4));
                        var sateDocBeforeAfterNDA_bip = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 5));
                    }
                    if (!isNullOrUndefined(state) && state.code == "KS" && !isNullOrUndefined(this.contractSession) && (this.contractSession.CountryID == 1) && sateDocBeforeAfterNDA_bip)
                        docIds = docIds.replace("AD", sateDocBeforeAfterNDA_bip.id.toString());
                    else if (sateDocBeforeAfterNDA && sateDocBeforeAfterNDA_bip && this.productId < 9)
                        docIds = docIds.replace("AD", sateDocBeforeAfterNDA.id.toString() + "," + sateDocBeforeAfterNDA_bip.id.toString());
                    else if (sateDocBeforeAfterNDA && sateDocBeforeAfterNDA_bip && this.productId >= 9)
                        docIds = docIds.replace("AD", sateDocBeforeAfterNDA.id.toString());
                    else
                        docIds = docIds.replace(",AD", "");
                }
            }
            else if (this.productId == 3 || (this.productId >= 7 || this.productId <= 10))//export for Sub ,sub only, IMP
            {
                //submission Agreemet

                var submissionAgreementDoc = this.contractSession.CountryID > 2 ? (this.configDocuments.docsList.find(i => i.id == 131 && i.agreement == false && i.docType == -1))
                    : (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == -1));
                submissionAgreementDoc = submissionAgreementDoc != null ? submissionAgreementDoc :
                    (this.configDocuments.docsList.find(i => i.id == 66 && i.agreement == false && i.docType == -1));

                if (submissionAgreementDoc)
                    docIds = docIds.replace("SA", submissionAgreementDoc.id.toString());
                else
                    docIds = docIds.replace(",SA", "");

                //Addendum Service
                var addendum = this.addendumServicesResponse.addendum.isNoService;
                if (this.addendumServicesResponse.addendum.isNoService) {
                    docIds = docIds.replace("82,", "").replace("83,", "").replace("84,", "").replace("85,", "").replace("86,", "").replace("87,", "").replace("88,", "").replace("89,", "").replace("137,", "").replace("138,", "").replace("139,", "").replace("140,", "");
                }
                else {
                    if (!this.addendumServicesResponse.addendum.isAddendumB)
                        docIds = this.isWestern ? docIds.replace("89,", "") : docIds.replace("88,", "");

                    if (!this.addendumServicesResponse.addendum.isAddendumG)
                        docIds = this.isWestern ? docIds.replace("87,", "") : docIds.replace("86,", "");

                    if (!this.addendumServicesResponse.addendum.isAddendumP)
                        docIds = this.isWestern ? docIds.replace("85,", "").replace("138,", "").replace("140,", "") : docIds.replace("84,", "").replace("137,", "").replace("139,", "");

                    if (!this.addendumServicesResponse.addendum.isPatentServices)
                        docIds = this.isWestern ? docIds.replace("83,", "") : docIds.replace("82,", "");
                }

                //Additional Docs
                if (!isNullOrUndefined(this.configDocuments)) {
                    var sateDocBeforeNDA = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 1));
                    var sateDocBeforeAfterNDA = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 4));
                }
                if (!this.navigation.isNDADoc) {
                    docIds = docIds.replace(",AD", "");
                }
                else {
                    if (sateDocBeforeAfterNDA)
                        docIds = docIds.replace("AD", sateDocBeforeAfterNDA.id.toString());
                    else
                        docIds = docIds.replace(",AD", "");
                }
            }
            else if (this.productId == 4) {
                if (!this.addendumServicesResponse.addendum.isPatentServices)
                    docIds = this.isWestern ? docIds.replace(",125", "") : docIds.replace(",124", "");
                var addldoc = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 4));
                if (addldoc)
                    docIds = docIds.replace("AD", addldoc.id.toString());
                else
                    docIds = docIds.replace(",AD", "");
            }
            else if (this.productId == 5) {
                if (!this.addendumServicesResponse.addendum.isPatentServices)
                    docIds = this.isWestern ? docIds.replace(",136", "") : docIds.replace(",134", "");
                var addldoc = (this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == false && i.docType == 4));
                if (addldoc)
                    docIds = docIds.replace("AD", addldoc.id.toString());
                else
                    docIds = docIds.replace(",AD", "");
            }
            if (this.isSecondContract) {
                docIds = docIds.replace(",3,", ",").replace(",4", "").replace(",1,", ",").replace(",38,", ",");
                if ((this.contractPayment.paymentOptionId == 1 || this.contractPayment.paymentOptionId == 0) && (this.contractSession.CountryID > 2) && ((this.productId == 4) || (this.productId == 5)))
                    docIds = docIds.replace("124,1", "124").replace("134,1", "134").replace("125,1", "125").replace("136,1", "136");
            }
            if (!this.navigationResponse.navigation.isPayCollectForm)
                docIds = docIds.replace("35,", "");

            //Wait state
            var waitstateDoc = this.configDocuments.docsList.find(i => i.stateId == stateid && i.agreement == true);
            if (!isNullOrUndefined(state) && state.waitDays > 0)
                docIds = docIds.replace("W", waitstateDoc.id.toString());
            else
                docIds = docIds.replace(",W", "");

            if (!this.isStateExists) {
                if (this.contractPayment) {
                    if ((this.isSecondContract && this.contractPayment.paymentOptionId == 1) || (this.contractPayment.paymentOptionId == 0))
                        docIds = docIds.replace(",0", "");
                    else
                        docIds = docIds.replace(",0,", ",").replace(",0", "");

                    console.log("SDA : " + docIds);
                }
            }

            if (docIds.length > 2 && (this.productId == 1 || this.productId == 2)) {
                if (!this.navigationResponse.navigation.isROIForm) {
                    if (((this.flgInstallment) || (this.isWaitStateExists))
                        || sateDocBeforeNDA || sateDocBeforeAfterNDA || (!isNullOrUndefined(state) && state.code == "KS"))
                        docIds = docIds.replace(",2,", ",");
                    else {
                        if (this.navigationResponse) {
                            if (this.navigationResponse.navigation.isNDADoc) {
                                docIds = docIds.substring(0, docIds.length - 2);
                            }
                        }
                        console.log("ROI2 : " + docIds);
                    }
                }
            }
            if (docIds.length > 2 && !isNullOrUndefined(this.navigationResponse) && !this.navigationResponse.navigation.isROIForm && ((this.productId == 6 && !this.isBIPExist) || this.productId == 11)) {
                docIds = docIds.substring(0, docIds.length - 2);
            }
        }

        return docIds;
    }

    showFileNumberList() {
        if (!isNullOrUndefined(this.inventHelp_CS_Site)) {
            this.fileNumberURL = this.inventHelp_CS_Site.configValue + 'file-numbers-list/' + this.clpUserId + '/1/' + this.encryptedUser;
            window.open(this.fileNumberURL, '_blank');
        }
    }
}
